<template>
  <div>
    <div :id="containerId" :class="`layerLevel${zIndex}`"></div>
  </div>
</template>

<script>
import * as V3DApp from '@/verge3d/appLanding.js'
import {
  tweenCamera,
  passInstance,
  getGroupNames,
  getAnimations,
  operateAnimation,
  registerSetTimeout,
  setActiveCamera,
  handleAnnot,
  resetGlobals
} from '@/verge3d/vergeLib.js'

export default {
  name: 'V3DScroll',
  props: {
    scene: {
      type: Object,
      required: true
    },
    playAfterMount: {
      type: Object
    },
    zIndex: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      containerId: V3DApp.CONTAINER_ID,
      camera: null,
      groupNames: null,
      animations: [],
      annotationsInit: false,
      annotationEl: []
    }
  },
  vergeApp: null,
  mounted: function() {
    var REL_URL_PREFIX = `/vergescenes/${this.scene.name}/`
    var FILE_TYPE = this.scene.compressed ? 'gltf.xz' : 'gltf'
    var FILE_PATH = `/vergescenes/${this.scene.name}/${this.scene.name}.${FILE_TYPE}`
    const PUZZLES_ENABLED = this.scene.puzzles ? this.scene.puzzles : false
    const TRANS_BACKGROUND = this.scene.transBackground
    let vm = this

    if (PUZZLES_ENABLED) {
      V3DApp.createApp(
        REL_URL_PREFIX,
        FILE_PATH,
        PUZZLES_ENABLED,
        TRANS_BACKGROUND
      )
    } else {
      const [app, sceneURL] = V3DApp.createApp(
        REL_URL_PREFIX,
        FILE_PATH,
        PUZZLES_ENABLED,
        TRANS_BACKGROUND
      )
      // moved load scene out of appLanding.js
      // in order to run vm.initApp(app) once loadScene has finshed
      app.loadScene(
        sceneURL,
        function() {
          app.enableControls()
          app.run()
          vm.initApp(app)
          // initApp not accessilbe in this scope but under vm
        },
        null,
        function() {
          console.log("Can't load the scene " + sceneURL)
        }
      )
      this.$options.vergeApp = app
    }
  },
  methods: {
    tweenCam(position, direction, time, Camtype) {
      tweenCamera(position, direction, time, function() {}, Camtype)
    },
    runAnimation() {
      this.animations.forEach(el => {
        operateAnimation(
          'PLAY',
          el,
          null,
          null,
          'LoopOnce',
          1,
          function() {},
          undefined,
          false
        )
      })
    },
    setFrame(frame) {
      this.animations.forEach(el => {
        operateAnimation(
          'SET_FRAME',
          el,
          frame,
          null,
          'AUTO',
          1,
          function() {},
          undefined,
          false
        )
      })
    },
    selectCamera(camera) {
      setActiveCamera(camera)
      // tweenCamera('', 'CAMERA TARGET', 0, function() {}, undefined)
      // tweenCamera('', [0, 0, 0], 0, function() {}, undefined)
    },
    toggleAnotations(state) {
      if (!this.annotationsInit) {
        this.scene.annotations.forEach(anno => {
          handleAnnot(state, anno.text, anno.anchor, '', anno.anchor)
          const el = document.querySelector(`#${anno.anchor}`)
          this.annotationEl.push(el)
          el.onclick = event => {
            this.$emit('annotationClick', anno.anchor)
          }
        })
        this.annotationsInit = true
      } else {
        this.scene.annotations.forEach(anno => {
          const el = document.querySelector(`#${anno.anchor}`)
          el.style.display = state ? 'inline' : 'none'
        })
      }
    },
    // ! init vergeLib and functions after starting vergescene
    initApp(app) {
      // pass app instance to logic library
      passInstance(app)
      this.groupNames = getGroupNames()
      this.groupNames.forEach(item => {
        this.animations.push(...getAnimations(['GROUP', item]))
      })
      // prettier-ignore
      function animateAfterMount(animations, options){
        return new Promise(function(resolve){
          animations.forEach(el => {
              operateAnimation('PLAY', el, 0, options.frame, 'AUTO', options.speed, function(){
                resolve('done')
              }, undefined, false )
          })
        })
      }
      let vm = this
      registerSetTimeout(0.5, function() {
        animateAfterMount(vm.animations, vm.playAfterMount)
          .then(value => {
            vm.$emit('vergeInitialized')
          })
          .catch(err => console.log(err))
      })
    }
  },
  beforeDestroy() {
    // clearn up app instance and reletated memory
    if (!this.$options.vergeApp) {
      // when using puzzles the verge app is not exported
      // on createApp()
      this.$options.vergeApp = V3DApp.getAppInstance()
    }
    this.$options.vergeApp.dispose()
    this.$options.vergeApp = null
    // reset verge utility library
    passInstance(null)
    resetGlobals()
    // remove event listeners for anchors
    this.annotationEl.forEach(el => {
      el.onclick = null
    })
    this.annotationEl = null
  }
}
</script>

<style>
/* todo: append wegl directly to div in template */
#v3d-container-scroll {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  /* min-height: 100%; */
  height: 100vh;
  /* z-index: 1; */
}

.layerLevel1 {
  z-index: 1;
}

.layerLevel0 {
  z-index: 0;
}

.layerLevel2 {
  z-index: 2;
}

.layerLevel3 {
  z-index: 3;
}

.v3d-annotation {
  height: auto;
  width: auto;
  padding: 2px 12px;
}

.fullscreen-button {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 50px;
  height: 50px;
  cursor: pointer;
  background-size: 100% 100%;
  display: none;
}

.fullscreen-open {
  background-image: url('/verge3d/3dcube/media/fullscreen_open.svg');
}

.fullscreen-close {
  background-image: url('/verge3d/3dcube/media/fullscreen_close.svg');
}

/* removes tap blinking on ios devices */
* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.v3d-simple-preloader-background {
  background: #01000a;
}

.v3d-simple-preloader-logo {
  background-image: url('/images/virtueinnovations.png');
  background-size: cover;
}

.v3d-simple-preloader-bar {
  background: white;
}

/* can import the verge css as well if somehow needed */
/* @import '../verge3d/app.css'; */
</style>
